if (process.env.NODE_ENV === 'test') {
  console.log('FX DISABLED');
  global.$.fx.off = true;
}
